export default __webpack_public_path__ + "3b4d104a5606bff60c5a841029f47e92.svg";